// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"dc7510c9","513":"84f0cada","703":"06ca2527","787":"59c230b2"}[chunkId] + ".chunk.js";
};